const breadCrumb = "Diário Digital - Horário de Recuperação";

const routes = [
  {
    path: "/horario-recuperacao",
    name: "horario-recuperacao",
    meta: {
      allowedPermissions: ["unidade_didatica_list"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ParametrosDiario/HorarioRecuperacao/HorarioRecuperacaoHome.vue"
      ),
  },
  {
    path: "/horario-recuperacao/novo/:turmaId",
    name: "horario-recuperacao-novo",
    meta: {
      allowedPermissions: ["unidade_didatica_insert"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ParametrosDiario/HorarioRecuperacao/HorarioRecuperacaoCad.vue"
      ),
  },
];

export default routes;
